import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { DsbFormSchema } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getDsbFormVersionSchema(axios: AxiosInstance, id: number): Promise<DsbFormSchema> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/dsb-form-version/${id}/schema`);
  return data;
}

export default function useDsbFormVersionSchemaQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getDsbFormVersionSchema(axios, id),
    enabled: !!id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

export function getKey(id: number) {
  return ['DsbFormVersionSchema', id] as const satisfies QueryKey;
}
useDsbFormVersionSchemaQuery.getKey = getKey;
